import { IconInfoCircle } from '@tabler/icons-react'
import { Tooltip } from 'antd'
import styled from 'styled-components'

import { useLocale } from '@/context/localeContext'
import { useNavigation } from '@/context/navigationContext'

import { buildPassTheme } from 'src/styles/theme'

const PageTitle = styled.span`
  ${({ theme }) => theme.font.heading02}
  color: ${({ theme }) => theme.colour.secondary._900};
  margin-right: 1rem;
  display: inline-block;
`

type Props = {
  titleOverride?: React.ReactNode
  titleExtra?: React.ReactNode
}

export const CorePageTitle: React.FC<Props> = ({
  titleOverride,
  titleExtra,
}) => {
  const { currentNavItem } = useNavigation()
  const { t } = useLocale()

  return (
    <PageTitle>
      {titleOverride ?? t(currentNavItem?.title)}
      {currentNavItem?.help && (
        <Tooltip title={t(currentNavItem?.help)}>
          <IconInfoCircle
            size={16}
            stroke={1.5}
            color={buildPassTheme.colour.secondary._400}
            style={{ marginLeft: '0.5rem' }}
          />
        </Tooltip>
      )}
      {titleExtra && <span style={{ marginLeft: '0.5rem' }}>{titleExtra}</span>}
    </PageTitle>
  )
}
